// import { GET_CAPTURE_DATA } from '../types'
import log from 'loglevel'
import { trackPromise } from 'react-promise-tracker'
import { getToken } from './auth'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getCaptureData = (Filter, setData) => {
  return async function (dispatch, getState) {
    const { token, tokenExp, accountId, supervisorID } = getState().auth
    const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)

    const body = { filter: { units: Filter.units, supervisorID } }
    if (!body.filter.units || !body.filter.units.length) { body.filter.units = getState().auth.assignedUnits }
    if (!body.filter.units || !body.filter.units.length) { return false }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/metrics`, options))

    if (!response.status || response.status === 401 || response.status === 500) {
      log.warn('non-200 status code from capture metrics')
    } else {
      const { data } = await response.json()
      if (!data) { return false }
      // log.debug(data)
      setData(data.aggregations)
    }
  }
}
